import { ProjectsListContextProvider } from "./ProjectsListContext";

function Contexts({ children }: any) {
	return (
		<ProjectsListContextProvider>{children}</ProjectsListContextProvider>
	);
}

export default Contexts;
